'use strict';

var setPrototypeOf$1 = require('./setPrototypeOf.js');

var setPrototypeOf = setPrototypeOf$1.setPrototypeOf;

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

module.exports = inherits;
